<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
/* CSS变量定义 */
:root {
  --theme-primary: #667eea;
  --theme-primary-dark: #5568d3;
  --theme-primary-light: #8194f0;
  --theme-text: #303133;
}

/* 全局样式 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* 全局滚动条样式 */
::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

::-webkit-scrollbar-track {
  background: #f5f7fa;
  border-radius: 5px;
}

::-webkit-scrollbar-thumb {
  background: linear-gradient(180deg, #c8d0e0 0%, #b8c0d8 100%);
  border-radius: 5px;
  border: 2px solid #f5f7fa;
  transition: all 0.3s;
}

::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(180deg, var(--theme-primary, #667eea) 0%, var(--theme-primary-dark, #5568d3) 100%);
  border-color: #e8edf3;
}

::-webkit-scrollbar-corner {
  background: #f5f7fa;
}

/* 全局样式重置 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body,
html {
  margin: 0 !important;
  padding: 0 !important;
  width: 100%;
  overflow-x: hidden;
}

#app {
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  min-height: 100vh;
  background: #f5f7fa;
  transition: background-color 0.3s;
  margin: 0 !important;
  padding: 0 !important;
}

/* 深色模式全局样式 */
.dark-mode {
  background: #1a1a1a;
  color: var(--theme-text);
}

.dark-mode #app {
  background: #1a1a1a;
}

/* 深色模式 Element UI 组件覆盖 */
.dark-mode .el-card {
  background: #2a2a2a;
  border-color: #404040;
  color: var(--theme-text);
}

.dark-mode .el-input__inner {
  background: #2a2a2a !important;
  border-color: #404040 !important;
  color: var(--theme-text) !important;
}

.dark-mode .el-input__inner::placeholder {
  color: rgba(var(--theme-text-rgb, 248, 245, 245), 0.5) !important;
}

.dark-mode .el-textarea__inner {
  background: #2a2a2a !important;
  border-color: #404040 !important;
  color: var(--theme-text) !important;
}

.dark-mode .el-select-dropdown {
  background: #2a2a2a !important;
  border-color: #404040 !important;
}

.dark-mode .el-select-dropdown__item {
  color: var(--theme-text) !important;
}

.dark-mode .el-select-dropdown__item:hover {
  background: #404040 !important;
}

.dark-mode .el-dropdown-menu {
  background: #2a2a2a !important;
  border-color: #404040 !important;
}

.dark-mode .el-dropdown-menu__item {
  color: var(--theme-text) !important;
}

.dark-mode .el-dropdown-menu__item:hover {
  background: #404040 !important;
}

.dark-mode .el-dropdown-menu__item.is-disabled {
  color: rgba(var(--theme-text-rgb, 248, 245, 245), 0.3) !important;
}

.dark-mode .el-dropdown-menu__item--divided {
  border-top-color: #404040 !important;
}

.dark-mode .el-dropdown-menu__item--divided::before {
  background: #404040 !important;
}

.dark-mode .el-table {
  background: #2a2a2a !important;
  color: var(--theme-text) !important;
}

.dark-mode .el-table th,
.dark-mode .el-table tr {
  background: #2a2a2a !important;
  color: var(--theme-text) !important;
}

.dark-mode .el-table td,
.dark-mode .el-table th.is-leaf {
  border-bottom-color: #404040 !important;
}

.dark-mode .el-table__body tr:hover > td {
  background: #333333 !important;
}

.dark-mode .el-pagination {
  color: var(--theme-text);
}

.dark-mode .el-pagination button {
  background: #2a2a2a;
  color: var(--theme-text);
  border-color: #404040 !important;
}

.dark-mode .el-pagination button:disabled {
  background: #1a1a1a !important;
  color: rgba(var(--theme-text-rgb, 248, 245, 245), 0.3) !important;
}

.dark-mode .el-pager li {
  background: #2a2a2a;
  color: var(--theme-text);
  border-color: #404040 !important;
}

.dark-mode .el-pager li:hover {
  color: var(--theme-text) !important;
}

.dark-mode .el-pager li.active {
  background: var(--theme-primary, #667eea);
  color: white;
}

.dark-mode .el-pagination__total,
.dark-mode .el-pagination__jump {
  color: var(--theme-text) !important;
}

.dark-mode .el-pagination__sizes .el-input__inner {
  background: #2a2a2a !important;
  border-color: #404040 !important;
  color: var(--theme-text) !important;
}

.dark-mode .el-pagination.is-background .btn-prev,
.dark-mode .el-pagination.is-background .btn-next,
.dark-mode .el-pagination.is-background .el-pager li {
  background: #2a2a2a !important;
  color: var(--theme-text) !important;
  border-color: #404040 !important;
}

.dark-mode .el-pagination.is-background .btn-prev:not(:disabled):hover,
.dark-mode .el-pagination.is-background .btn-next:not(:disabled):hover,
.dark-mode .el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: var(--theme-text) !important;
  background: #333333 !important;
}

.dark-mode .el-pagination.is-background .el-pager li:not(.disabled).active {
  background: var(--theme-primary, #667eea) !important;
  color: white !important;
}

/* 深色模式 Popover/Popper 组件 */
body.dark-mode .el-popover,
body.dark-mode .el-popper,
html.dark-mode .el-popover,
html.dark-mode .el-popper,
.dark-mode .el-popover,
.dark-mode .el-popper {
  background-color: #2a2a2a !important;
  background: #2a2a2a !important;
  border-color: rgba(102, 126, 234, 0.2) !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.6) !important;
  color: var(--theme-text) !important;
}

body.dark-mode .el-popover .popper__arrow,
body.dark-mode .el-popper .popper__arrow,
html.dark-mode .el-popover .popper__arrow,
html.dark-mode .el-popper .popper__arrow,
.dark-mode .el-popover .popper__arrow,
.dark-mode .el-popper .popper__arrow {
  border-bottom-color: #2a2a2a !important;
}

body.dark-mode .el-popover .popper__arrow::after,
body.dark-mode .el-popper .popper__arrow::after,
html.dark-mode .el-popover .popper__arrow::after,
html.dark-mode .el-popper .popper__arrow::after,
.dark-mode .el-popover .popper__arrow::after,
.dark-mode .el-popper .popper__arrow::after {
  border-bottom-color: #2a2a2a !important;
}

body.dark-mode .el-popover[x-placement^="bottom"] .popper__arrow::after,
html.dark-mode .el-popover[x-placement^="bottom"] .popper__arrow::after,
.dark-mode .el-popover[x-placement^="bottom"] .popper__arrow::after {
  border-bottom-color: #2a2a2a !important;
}

body.dark-mode .el-popover[x-placement^="top"] .popper__arrow::after,
html.dark-mode .el-popover[x-placement^="top"] .popper__arrow::after,
.dark-mode .el-popover[x-placement^="top"] .popper__arrow::after {
  border-top-color: #2a2a2a !important;
}

/* 深色模式滚动条 */
.dark-mode ::-webkit-scrollbar-track {
  background: #1a1a1a;
}

.dark-mode ::-webkit-scrollbar-thumb {
  background: linear-gradient(180deg, #4a4a4a 0%, #3a3a3a 100%);
  border: 2px solid #1a1a1a;
}

.dark-mode ::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(180deg, var(--theme-primary, #667eea) 0%, var(--theme-primary-dark, #5568d3) 100%);
  border-color: #2a2a2a;
}

.dark-mode ::-webkit-scrollbar-corner {
  background: #1a1a1a;
}

/* 深色模式弹窗内容 */
body.dark-mode .el-popover__title,
html.dark-mode .el-popover__title {
  color: var(--theme-text) !important;
}

body.dark-mode .el-button--text,
html.dark-mode .el-button--text {
  color: #8ea4f5 !important;
}

body.dark-mode .el-button--text:hover,
html.dark-mode .el-button--text:hover {
  color: #a8bbf7 !important;
}

/* 深色模式输入框字数统计 */
body.dark-mode .el-textarea .el-input__count,
html.dark-mode .el-textarea .el-input__count,
.dark-mode .el-textarea .el-input__count {
  background: #2a2a2a !important;
  color: #8a8a8a !important;
}

body.dark-mode .el-input__count,
html.dark-mode .el-input__count,
.dark-mode .el-input__count {
  background: #2a2a2a !important;
  color: #8a8a8a !important;
}

/* 深色模式 Dialog 对话框 */
body.dark-mode .el-dialog,
html.dark-mode .el-dialog,
.dark-mode .el-dialog {
  background: #2a2a2a !important;
  border: 1px solid rgba(102, 126, 234, 0.2) !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.6) !important;
}

body.dark-mode .el-dialog__header,
html.dark-mode .el-dialog__header,
.dark-mode .el-dialog__header {
  background: #2a2a2a !important;
  border-bottom-color: rgba(102, 126, 234, 0.2) !important;
}

body.dark-mode .el-dialog__title,
html.dark-mode .el-dialog__title,
.dark-mode .el-dialog__title {
  color: var(--theme-text) !important;
}

body.dark-mode .el-dialog__body,
html.dark-mode .el-dialog__body,
.dark-mode .el-dialog__body {
  background: #2a2a2a !important;
  color: var(--theme-text) !important;
}

body.dark-mode .el-dialog__footer,
html.dark-mode .el-dialog__footer,
.dark-mode .el-dialog__footer {
  background: #2a2a2a !important;
  border-top-color: rgba(102, 126, 234, 0.2) !important;
}

body.dark-mode .el-dialog__close,
html.dark-mode .el-dialog__close,
.dark-mode .el-dialog__close {
  color: #8a8a8a !important;
}

body.dark-mode .el-dialog__close:hover,
html.dark-mode .el-dialog__close:hover,
.dark-mode .el-dialog__close:hover {
  color: var(--theme-text) !important;
}

/* 深色模式遮罩层 */
body.dark-mode .v-modal,
html.dark-mode .v-modal,
.dark-mode .v-modal {
  background-color: rgba(0, 0, 0, 0.7) !important;
}

/* 深色模式 Alert 提示框 */
body.dark-mode .el-alert,
html.dark-mode .el-alert,
.dark-mode .el-alert {
  background-color: #2a2a2a !important;
  border-color: rgba(102, 126, 234, 0.3) !important;
}

body.dark-mode .el-alert__title,
html.dark-mode .el-alert__title,
.dark-mode .el-alert__title {
  color: var(--theme-text) !important;
}

body.dark-mode .el-alert__description,
html.dark-mode .el-alert__description,
.dark-mode .el-alert__description {
  color: #b0b0b0 !important;
}

body.dark-mode .el-alert p,
html.dark-mode .el-alert p,
.dark-mode .el-alert p {
  color: #b0b0b0 !important;
}

body.dark-mode .el-alert strong,
html.dark-mode .el-alert strong,
.dark-mode .el-alert strong {
  color: var(--theme-text) !important;
}

body.dark-mode .el-alert.el-alert--info,
html.dark-mode .el-alert.el-alert--info,
.dark-mode .el-alert.el-alert--info {
  background-color: rgba(102, 126, 234, 0.15) !important;
  border-color: rgba(102, 126, 234, 0.4) !important;
}

body.dark-mode .el-alert.el-alert--success,
html.dark-mode .el-alert.el-alert--success,
.dark-mode .el-alert.el-alert--success {
  background-color: rgba(103, 194, 58, 0.15) !important;
  border-color: rgba(103, 194, 58, 0.4) !important;
}

body.dark-mode .el-alert.el-alert--warning,
html.dark-mode .el-alert.el-alert--warning,
.dark-mode .el-alert.el-alert--warning {
  background-color: rgba(230, 162, 60, 0.15) !important;
  border-color: rgba(230, 162, 60, 0.4) !important;
}

body.dark-mode .el-alert.el-alert--error,
html.dark-mode .el-alert.el-alert--error,
.dark-mode .el-alert.el-alert--error {
  background-color: rgba(245, 108, 108, 0.15) !important;
  border-color: rgba(245, 108, 108, 0.4) !important;
}

/* Primary 按钮主题配置 */
.el-button--primary {
  background-color: var(--theme-primary, #667eea) !important;
  border-color: var(--theme-primary, #667eea) !important;
}

.el-button--primary:hover,
.el-button--primary:focus {
  background: var(--theme-primary-light, #7e8df0) !important;
  border-color: var(--theme-primary-light, #7e8df0) !important;
}

.el-button--primary:active {
  background: var(--theme-primary-dark, #5568d3) !important;
  border-color: var(--theme-primary-dark, #5568d3) !important;
}

.el-button--primary.is-disabled,
.el-button--primary.is-disabled:hover,
.el-button--primary.is-disabled:focus,
.el-button--primary.is-disabled:active {
  background-color: var(--theme-primary-light, #a0a8f5) !important;
  border-color: var(--theme-primary-light, #a0a8f5) !important;
}

/* Tab 标签页主题配置 */
.el-tabs__item.is-active {
  color: var(--theme-primary, #409EFF) !important;
}

.el-tabs__active-bar {
  background-color: var(--theme-primary, #409EFF) !important;
}

.el-tabs__item:hover {
  color: var(--theme-primary, #409EFF) !important;
}

/* Tag 标签主题配置 */
.el-tag--warning {
  background-color: #fdf6ec !important;
  border-color: #f5dab1 !important;
  color: #e6a23c !important;
}

.el-tag--success {
  background-color: #f0f9ff !important;
  border-color: #c6f6d5 !important;
  color: #67c23a !important;
}

/* 深色模式 Tab 标签 */
body.dark-mode .el-tabs__item.is-active,
html.dark-mode .el-tabs__item.is-active,
.dark-mode .el-tabs__item.is-active {
  color: var(--theme-primary, #667eea) !important;
}

body.dark-mode .el-tabs__active-bar,
html.dark-mode .el-tabs__active-bar,
.dark-mode .el-tabs__active-bar {
  background-color: var(--theme-primary, #667eea) !important;
}

body.dark-mode .el-tabs__item:hover,
html.dark-mode .el-tabs__item:hover,
.dark-mode .el-tabs__item:hover {
  color: var(--theme-primary, #667eea) !important;
}

body.dark-mode .el-tabs__item,
html.dark-mode .el-tabs__item,
.dark-mode .el-tabs__item {
  color: #b0b0b0 !important;
}

body.dark-mode .el-tabs__nav-wrap::after,
html.dark-mode .el-tabs__nav-wrap::after,
.dark-mode .el-tabs__nav-wrap::after {
  background-color: #404040 !important;
}

/* Link 链接主题配置 */
.el-link.el-link--primary {
  color: var(--theme-primary, #409EFF) !important;
}

.el-link.el-link--primary:hover {
  color: var(--theme-primary-light, #66b1ff) !important;
}

.el-link.el-link--primary:active {
  color: var(--theme-primary-dark, #3a8ee6) !important;
}

body.dark-mode .el-link.el-link--primary,
html.dark-mode .el-link.el-link--primary,
.dark-mode .el-link.el-link--primary {
  color: var(--theme-primary, #667eea) !important;
}

body.dark-mode .el-link.el-link--primary:hover,
html.dark-mode .el-link.el-link--primary:hover,
.dark-mode .el-link.el-link--primary:hover {
  color: var(--theme-primary-light, #7e8df0) !important;
}

/* Dropdown 下拉菜单主题配置 */
.el-dropdown-menu__item:hover {
  background-color: rgba(102, 126, 234, 0.1) !important;
  color: var(--theme-primary, #409EFF) !important;
}

.el-dropdown-menu__item i {
  color: var(--theme-primary, #409EFF) !important;
}

body.dark-mode .el-dropdown-menu__item:hover,
html.dark-mode .el-dropdown-menu__item:hover,
.dark-mode .el-dropdown-menu__item:hover {
  background-color: rgba(102, 126, 234, 0.2) !important;
  color: var(--theme-primary, #667eea) !important;
}

body.dark-mode .el-dropdown-menu__item i,
html.dark-mode .el-dropdown-menu__item i,
.dark-mode .el-dropdown-menu__item i {
  color: var(--theme-primary, #667eea) !important;
}

/* Pagination 分页主题配置 */
.el-pager li.active {
  background-color: var(--theme-primary, #409EFF) !important;
  color: #fff !important;
  border-color: var(--theme-primary, #409EFF) !important;
}

.el-pager li:hover {
  color: var(--theme-primary, #409EFF) !important;
}

.el-pagination button:hover {
  color: var(--theme-primary, #409EFF) !important;
}

body.dark-mode .el-pager li.active,
html.dark-mode .el-pager li.active,
.dark-mode .el-pager li.active {
  background-color: var(--theme-primary, #667eea) !important;
  color: #fff !important;
  border-color: var(--theme-primary, #667eea) !important;
}

body.dark-mode .el-pager li:hover,
html.dark-mode .el-pager li:hover,
.dark-mode .el-pager li:hover {
  color: var(--theme-primary, #667eea) !important;
}

body.dark-mode .el-pagination button:hover,
html.dark-mode .el-pagination button:hover,
.dark-mode .el-pagination button:hover {
  color: var(--theme-primary, #667eea) !important;
}

/* Text Button 文字按钮主题配置 */
.el-button--text {
  color: var(--theme-primary, #409EFF) !important;
}

.el-button--text:hover,
.el-button--text:focus {
  color: var(--theme-primary-light, #66b1ff) !important;
}

body.dark-mode .el-button--text,
html.dark-mode .el-button--text,
.dark-mode .el-button--text {
  color: var(--theme-primary, #667eea) !important;
}

body.dark-mode .el-button--text:hover,
html.dark-mode .el-button--text:hover,
body.dark-mode .el-button--text:focus,
html.dark-mode .el-button--text:focus,
.dark-mode .el-button--text:hover,
.dark-mode .el-button--text:focus {
  color: var(--theme-primary-light, #7e8df0) !important;
}

/* ==================== 移动端适配 ==================== */
/* 平板和移动端 */
@media (max-width: 1024px) {
  #app {
    font-size: 14px;
  }
}

/* 移动端 */
@media (max-width: 768px) {
  * {
    -webkit-tap-highlight-color: transparent;
  }
  
  body,
  html {
    margin: 0 !important;
    padding: 0 !important;
    overflow-x: hidden !important;
  }
  
  #app {
    font-size: 14px;
    margin: 0 !important;
    padding: 0 !important;
    width: 100% !important;
    max-width: 100vw !important;
    overflow-x: hidden !important;
  }
  
  /* Element UI 组件移动端优化 */
  .el-dialog {
    width: 95% !important;
    margin-top: 5vh !important;
  }
  
  .el-message-box {
    width: 90% !important;
  }
  
  .el-card {
    margin: 10px 0 !important;
  }
  
  /* 输入框移动端优化 */
  .el-input__inner,
  .el-textarea__inner {
    font-size: 16px !important; /* 防止iOS自动缩放 */
  }
  
  /* 按钮移动端优化 */
  .el-button {
    padding: 10px 15px;
  }
  
  .el-button--small {
    padding: 8px 12px;
  }
  
  .el-button--mini {
    padding: 6px 10px;
  }
  
  /* 表格移动端优化 */
  .el-table {
    font-size: 12px !important;
  }
  
  .el-table th,
  .el-table td {
    padding: 8px 0 !important;
  }
  
  /* 分页移动端优化 */
  .el-pagination {
    padding: 10px 5px !important;
    text-align: center !important;
  }
  
  .el-pagination .el-pager li {
    min-width: 28px !important;
    font-size: 13px !important;
  }
  
  .el-pagination button {
    padding: 0 8px !important;
  }
  
  /* 下拉菜单移动端优化 */
  .el-dropdown-menu {
    max-width: 90vw;
  }
  
  /* 滚动条移动端优化 */
  ::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }
  
  ::-webkit-scrollbar-thumb {
    border-width: 1px;
  }
}

/* 小屏手机 */
@media (max-width: 480px) {
  #app {
    font-size: 13px;
  }
  
  .el-dialog {
    width: 98% !important;
    margin: 10px auto !important;
  }
  
  .el-button {
    padding: 8px 12px;
    font-size: 13px;
  }
}
</style>